import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { fulfillmentMeta } from '../routes/metaData'
const DefaultFulfillmentScreen = observer((props: any) => {
   const history = useHistory()
   useEffect(() => {
      history.push(fulfillmentMeta[0].path)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return null
})

export default DefaultFulfillmentScreen
